import { useSharedState } from '@trello/shared-state';

import { globalThemeState, type GlobalThemeState } from './globalThemeState';

export const useGlobalTheme = (): GlobalThemeState => {
  const [state] = useSharedState(globalThemeState, {
    onlyUpdateIfChanged: true,
  });

  return state;
};
